import { mmkvStorage } from '@/stores/middleware/mmkv-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type AppState = {
  theme: 'light' | 'dark' | 'system';
  locale: string;
};

type AppActions = {
  setTheme: (theme: AppState['theme']) => void;
  setLocale: (locale: string) => void;
  reset: () => void;
};

const initialState: AppState = {
  theme: 'system',
  locale: 'en',
};

export const useAppStore = create<AppState & AppActions>()(
  persist(
    set => ({
      ...initialState,
      setTheme: theme => set({ theme }),
      setLocale: locale => set({ locale }),
      reset: () => set(initialState),
    }),
    {
      name: 'app-store',
      storage: createJSONStorage(() => mmkvStorage),
    },
  ),
);
